var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUserGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9055_151065)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 29,
    height: 29,
    rx: 5,
    fill: "#43AC43"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 24C24.2091 24 26 22.2091 26 20C26 17.7909 24.2091 16 22 16C19.7909 16 18 17.7909 18 20C18 22.2091 19.7909 24 22 24ZM22.5714 18.2857V19.4286H23.7143C24.0299 19.4286 24.2857 19.6844 24.2857 20C24.2857 20.3156 24.0299 20.5714 23.7143 20.5714H22.5714V21.7143C22.5714 22.0299 22.3156 22.2857 22 22.2857C21.6844 22.2857 21.4286 22.0299 21.4286 21.7143V20.5714H20.2857C19.9701 20.5714 19.7143 20.3156 19.7143 20C19.7143 19.6844 19.9701 19.4286 20.2857 19.4286H21.4286V18.2857C21.4286 17.9701 21.6844 17.7143 22 17.7143C22.3156 17.7143 22.5714 17.9701 22.5714 18.2857Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2857 11.4286C20.2857 13.3221 18.7507 14.8571 16.8571 14.8571C14.9636 14.8571 13.4286 13.3221 13.4286 11.4286C13.4286 9.53502 14.9636 8 16.8571 8C18.7507 8 20.2857 9.53502 20.2857 11.4286ZM16.8571 13.7143C18.1195 13.7143 19.1429 12.6909 19.1429 11.4286C19.1429 10.1662 18.1195 9.14286 16.8571 9.14286C15.5948 9.14286 14.5714 10.1662 14.5714 11.4286C14.5714 12.6909 15.5948 13.7143 16.8571 13.7143Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1498 21.7143C17.0207 21.3492 16.9317 20.9651 16.8881 20.5674H11.1429C11.1445 20.2854 11.3186 19.4405 12.0938 18.6653C12.8393 17.9198 14.241 17.1429 16.8571 17.1429C17.1548 17.1429 17.4368 17.1529 17.7039 17.1719C17.9612 16.7818 18.2703 16.4288 18.6212 16.1227C18.0881 16.0436 17.5017 16 16.8571 16C11.1429 16 10 19.4286 10 20.5714C10 21.7143 11.1429 21.7143 11.1429 21.7143H17.1498Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9055_151065",
    x: 0,
    y: 0,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9055_151065"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9055_151065",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserGreenIcon);
export default __webpack_public_path__ + "static/media/add-user-green-icon.b93efd094e6cf0fd4a598990f92ae0c4.svg";
export { ForwardRef as ReactComponent };